export interface ICombineGameIdItem {
  id?: string;
}

/**
 * 从 combined_ids 结果构建 event_cluster 请求的 game_ids
 */
export function buildEventClusterGameIds(
  combineGameIdList?: ICombineGameIdItem[],
  fallbackGameId?: string,
): string[] {
  const ids = (combineGameIdList || [])
    .map(item => item?.id)
    .filter((id): id is string => !!id && id !== 'None' && id !== '');

  if (ids.length > 0) {
    return ids;
  }

  return fallbackGameId ? [fallbackGameId] : [];
}
